import React from 'react';

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { GET_DEVICES_BY_PROJECT } from 'gql/device.operations';
import { MdmDeviceDto, useCreateDeviceMutation } from 'gql/generated/types';
import { useNavigate, useParams } from 'react-router-dom';
import DeviceForm from '../components/DeviceForm';

const NewDeviceForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [createDeviceMutation] = useCreateDeviceMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Device created successfully",
        life: 3000,
      });
      navigate(`/${projectId}/devices`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
  });

  const handleCreate = (device: Partial<MdmDeviceDto>) => {
    const { objectRelation, project, ...restDevice } = device
    createDeviceMutation({
      variables: { device: { ...restDevice, roleInObject: objectRelation?.roleInObject }, objectId: device.objectRelation?.mdmObject?.id! },
      update: (cache, { data }) => {
        cache.updateQuery({ query: GET_DEVICES_BY_PROJECT, variables: {id: projectId}}, (oldData) => oldData ? ({ 
          mdmDevicesByProjectId: [...oldData.mdmDevicesByProjectId, data?.createMdmDevice]
        }) : null );
      }
    });
  };
  
  return (
    <DeviceForm device={null} onSubmit={handleCreate} newForm/>
  )
}

export default NewDeviceForm